export default "__VITE_ASSET__37002b42__"